import React from 'react';
import styles from './ProfilCard.module.css';
import { optionsList } from "./SuggestionList";

const ProfilFooter = () => {
    return (
        <section className={styles.footer}>
          {optionsList.map((option, index) => (
            <div key={index} className={styles.suggestion}>
                <img className={styles.lableIcon} src={option.icon} alt={option.label} />
                <label className={styles.label}>{option.label}</label>
            </div>
            ))}
        </section>
    );
};

export default ProfilFooter;